import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  pageTitle: {
    id: 'djcity.common.integrations.meta.title',
    defaultMessage: 'Effortless integration with all DJ software',
  },
  pageDescription: {
    id: 'djcity.common.integrations.meta.description',
    defaultMessage: 'Effortless integration with all DJ software',
  },
  title: {
    id: 'djcity.common.integrations.title',
    defaultMessage: 'Effortless integration with all DJ software',
  },
  subtitle: {
    id: 'djcity.common.integrations.subtitle',
    defaultMessage: 'Works with Serato, Rekordbox, Traktor, VirtualDJ and DJAY',
  },
  c2aTitle: {
    id: 'djcity.common.integrations.c2a.title',
    defaultMessage: 'High quality MP3 downloads, ready for your DJ software',
  },
  c2aButton: {
    id: 'djcity.common.integrations.c2a.button',
    defaultMessage: 'Join Now',
  },
  faqTitle: {
    id: 'djcity.common.integrations.faq.title',
    defaultMessage:
      'Frequently asked questions about DJcity record pool DJ software compatibility',
  },
})

export const logosMessages = defineMessages({
  serato: {
    id: 'djcity.common.logos.serato',
    defaultMessage: '/assets/cdn/serato_logo.png',
  },
  rekordbox: {
    id: 'djcity.common.logos.rekordbox',
    defaultMessage: '/assets/cdn/rekordbox_logo.png',
  },
  traktor: {
    id: 'djcity.common.logos.traktor',
    defaultMessage: '/assets/cdn/traktor_logo.png',
  },
  virtualdj: {
    id: 'djcity.common.logos.virtualdj',
    defaultMessage: '/assets/cdn/virtualdj_logo.png',
  },
  djay: {
    id: 'djcity.common.logos.djay',
    defaultMessage: '/assets/cdn/djay_logo.png',
  },
})

export const featuresMessages = [
  defineMessages({
    image: {
      id: 'djcity.common.integrations.feature1.image',
      defaultMessage: '/assets/cdn/integrations_feat1.png',
    },
    title: {
      id: 'djcity.common.integrations.feature1.title',
      defaultMessage: 'Full compatibility',
    },
    subTitle: {
      id: 'djcity.common.integrations.feature1.subTitle',
      defaultMessage: 'Our tracks work flawlessly with all DJ software.',
    },
  }),
  defineMessages({
    image: {
      id: 'djcity.common.integrations.feature2.image',
      defaultMessage: '/assets/cdn/integrations_feat2.png',
    },
    title: {
      id: 'djcity.common.integrations.feature2.title',
      defaultMessage: 'Pre-filled ID3 metadata',
    },
    subTitle: {
      id: 'djcity.common.integrations.feature2.subTitle',
      defaultMessage:
        'Every MP3 is pre-filled with artist, track title, BPM, and genre. Standardized cue points and beatgrids are also included for Serato',
    },
  }),
  defineMessages({
    image: {
      id: 'djcity.common.integrations.feature3.image',
      defaultMessage: '/assets/cdn/integrations_feat3.png',
    },
    title: {
      id: 'djcity.common.integrations.feature3.title',
      defaultMessage: 'STREAMLINED WORKFLOW',
    },
    subTitle: {
      id: 'djcity.common.integrations.feature3.subTitle',
      defaultMessage:
        'Start mixing instantly. Spend less time organizing your library and more time DJing.',
    },
  }),
]

export const faqMessages = [
  {
    uuid: '87e150b3-c21c-4d8f-9871-39ece36adfb8',
    msg: defineMessages({
      title: {
        id: 'djcity.common.integrations.faq.title1',
        defaultMessage:
          'Why Is DJcity the Best DJ Record Pool for Serato, Rekordbox, Traktor, and VirtualDJ?',
      },
      content: {
        id: 'djcity.common.integrations.faq.text1',
        defaultMessage:
          'DJcity offers high-quality 320kbps MP3 downloads, ensuring top-tier sound. <br/>Every track is pre-filled with metadata for effortless organization.',
      },
    }),
  },
  {
    uuid: '23134e2d-a9d0-4ad4-b11b-950a15590485',
    msg: defineMessages({
      title: {
        id: 'djcity.common.integrations.faq.title2',
        defaultMessage: 'How Do I Import DJcity Downloads into My DJ Software?',
      },
      content: {
        id: 'djcity.common.integrations.faq.text2',
        defaultMessage:
          'Simply drag and drop your downloaded tracks into your preferred DJ software. Your tracks are ready to mix in seconds.',
      },
    }),
  },
  {
    uuid: '410278a0-147b-45a9-8a7b-f5a3b82faf37',
    msg: defineMessages({
      title: {
        id: 'djcity.common.integrations.faq.title3',
        defaultMessage: 'What Type of Music and Genres Can I Find on DJcity?',
      },
      content: {
        id: 'djcity.common.integrations.faq.text3',
        defaultMessage:
          'DJcity offers a diverse selection of over 250 genres plus exclusive remixes and edits, catering to any event or audience.',
      },
    }),
  },
  {
    uuid: '7eae7385-820f-4a21-ad83-3317e7811d2a',
    msg: defineMessages({
      title: {
        id: 'djcity.common.integrations.faq.title4',
        defaultMessage: 'Why Do DJs Prefer DJcity Over Other DJ Record Pools?',
      },
      content: {
        id: 'djcity.common.integrations.faq.text4',
        defaultMessage:
          'DJs worldwide trust DJcity for its expert-curated playlists, broad genre selection, and seamless compatibility with all major DJ software.',
      },
    }),
  },
]
